import { useCallback as e, useState as d, useEffect as n } from "react";
import { subscribe as a, unsubscribe as u } from "@wh/message-bus";
import { formatOdds as c, oddsFormats as m } from "@wh/odds-formatter";
function g() {
  const t = i();
  return e(
    (o, r) => c(o, r, t),
    [t]
  );
}
function i() {
  const [t, o] = d(
    F()
  );
  return n(() => {
    const r = a(
      "onOddsFormatChanged",
      (O, s) => {
        o(s);
      }
    );
    return () => {
      u(r);
    };
  }, []), t;
}
function f() {
  const t = localStorage.getItem("Sportsbook");
  if (t)
    try {
      const { oddsFormat: o } = JSON.parse(t);
      return Object.values(m).includes(o) ? o : void 0;
    } catch {
      return;
    }
}
function F() {
  return f() || "fraction";
}
export {
  i as useOddsFormat,
  g as useOddsFormatter
};
